<app-page-panel class="flex-fit"
    [showBackButton]="false"
    iconNameFontAwesome="payments"
    [pageTitle]="this.allowEdit() ? 'Teilleistungen hinzufügen' : 'Teilleistungen anzeigen'"    
    [showBackColor]="true"
    [showDetailsButton]="false"
    [showSidepanelButton]="false"
    [showCloseButton]="true"
    [showContent]="false"
    (closeButtonClicked)="onCloseClick()">
</app-page-panel>
<form [formGroup]="teilleistungenForm" (ngSubmit)="onFormSubmit()">
    <mat-dialog-content>
        <div class="form-group flex flex-col flex-fill flex-stretch-self flex-justify">
            <div class="flex flex-row flex-fill flex-gap-12 flex-justify">
                <mat-form-field class="flex-fill">
                    <mat-label>Kostengruppe</mat-label>
                    <mat-select formControlName="Kostengruppe" name="controlling" cdkFocusInitial>
                        @for (item of dataKostengruppen(); track item) {
                            <mat-option [value]="item">{{item.kostengruppeLang}}</mat-option>
                        }                            
                    </mat-select>                        
                </mat-form-field>      
            </div>
            <dx-data-grid #gridTeilleistungen
                keyExpr="teilleistungID"
                [dataSource]="dataTeilleistungenFilterd()"
                [focusedRowEnabled]="true"
                [hoverStateEnabled]="true"
                [noDataText]="''"
                [height]="'522px'"
                [width]="'100%'" 
                (onSelectionChanged)="onSelectionChanged($event)"
                >
                <dxo-header-filter [visible]="true" search.enabled="true"></dxo-header-filter>                    
                <dxo-filter-row [visible]="true"></dxo-filter-row>             
                <dxi-column dataField="bezeichnungGrouping01" caption="Kostengruppe" width="30" [groupIndex]="0" sortOrder="asc"></dxi-column>
                <dxi-column dataField="bezeichnungGrouping02" caption="Untergruppe" width="30" [groupIndex]="1" sortOrder="asc"></dxi-column>
                <dxi-column dataField="nummer" width="120" [sortIndex]="0" sortOrder="asc"></dxi-column>
                <dxi-column dataField="bezeichnung"></dxi-column>
                <dxo-paging [enabled]="false" [pageSize]="100"></dxo-paging>
                <dxo-pager [visible]="false" displayMode="full" [showNavigationButtons]="true" [showPageSizeSelector]="true"></dxo-pager>             
                <dxo-scrolling mode="virtual" useNative="true"></dxo-scrolling>
                <dxo-selection selectAllMode="allPages" showCheckBoxesMode="always" mode="multiple"></dxo-selection> 
                <dxo-toolbar [visible]="true">
                    <dxi-item location="before">
                        <div *dxTemplate class="info-box">
                            <i class="dx-icon-formula dx-icon-info-box"></i>
                            {{gridDataCountText()}}
                        </div>
                    </dxi-item>
                    <dxi-item location="before">
                        <div *dxTemplate class="info-box">
                            <i class="dx-icon-check dx-icon-info-box"></i>
                            {{gridInfoText()}}
                        </div>
                    </dxi-item>     
                </dxo-toolbar>
                <dxo-grouping></dxo-grouping>
            </dx-data-grid>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        @if (this.allowEdit()) {
            <button mat-button type="submit" [disabled]="!isFormEditStateValid()">Speichern</button>
        }
        <button mat-button mat-dialog-close>{{ this.allowEdit() ? 'Abbrechen' : 'Schließen' }}</button>
    </mat-dialog-actions>
</form>
